import type { ISbStoryData } from '@storyblok/js'
import type { Page, SpotlightBanner } from '@percent/cause-dashboard/storyblok/types/storyblok-components'

export function extractFirstSpotlightBannerFromPageStory(story: ISbStoryData<Page>): SpotlightBanner | null {
  const body = story.content.body ?? []

  return (
    body.find(
      (blok): blok is SpotlightBanner =>
        typeof blok === 'object' && blok !== null && (blok as { component?: string }).component === 'spotlight_banner'
    ) ?? null
  )
}
